import Button from 'ext-ui/components/Button/Button'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import * as style from 'src/app/CardFeedDetails/components/CardFeedFailedEmptyState.style'
import NotFound from 'src/assets/images/404.svg'
import { useCurrentBrand } from 'src/context/ConfigContext/useConfig'
import { useTranslate } from 'src/localization/Trns'
import { createCardFeedUrl, supportRequestUrl } from 'src/navigation/urls'

const CardFeedFailedEmptyState: React.FC = () => {
  const translate = useTranslate()
  const { analytics } = useAnalyticsContext()
  const history = useHistory()
  const { EXTERNAL_SUPPORT_URL } = useCurrentBrand()
  const supportHref = EXTERNAL_SUPPORT_URL || supportRequestUrl()

  useEffect(() => {
    analytics.track('card feed details', {
      action: 'failed empty state viewed',
    })
  }, [analytics])

  const handleTryAgain = (): void => {
    analytics.track('card feed details', { action: 'try again clicked' })
    history.push({ pathname: createCardFeedUrl(), state: { initialStep: 2 } })
  }

  const handleContactSupport = (): void => {
    analytics.track('card feed details', { action: 'contact support clicked', variant: 'link' })
  }

  return (
    <div css={style.container} data-testid="card-feed-cards-failed">
      <img css={style.illustration} src={NotFound} alt="" />
      <p css={style.heading}>
        {translate('There was an error connecting the card feed')}
      </p>
      <p css={style.body}>
        {translate(
          'Something went wrong while setting up this feed. Try again, or reach out to support if the problem continues.',
        )}
      </p>
      <div css={style.ctaRow}>
        <a
          css={style.contactSupportLink}
          href={supportHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleContactSupport}
          data-testid="card-feed-failed-contact-support"
        >
          {translate('Contact Support')}
        </a>
        <Button
          variant="primary"
          onClick={handleTryAgain}
          data-testid="card-feed-failed-try-again"
        >
          {translate('Try Again')}
        </Button>
      </div>
    </div>
  )
}

export default CardFeedFailedEmptyState
